import React from 'react';

import { useLayout, LayoutType } from '@app/hooks/useLayout';
import DevLayout from '@app/layouts/dev';
import AuthLayout from '@layouts/auth';
import DashboardLayout from '@layouts/dashboard';
import DefaultLayout from '@layouts/default';
import SimpleLayout from '@layouts/simple';

interface WithLayoutProps {
  children: React.ReactNode;
  customLayout?: LayoutType;
}

const LayoutRenderer: React.FC<WithLayoutProps> = ({ children, customLayout }) => {
  const { type } = useLayout();

  const layoutType = customLayout || type;

  // Render layout dựa trên type
  switch (layoutType) {
    case 'simple':
      return <SimpleLayout>{children}</SimpleLayout>;

    case 'dashboard':
      return <DashboardLayout>{children}</DashboardLayout>;

    case 'auth':
      return <AuthLayout>{children}</AuthLayout>;

    case 'none':
      return <>{children}</>;

    case 'dev':
      return <DevLayout>{children}</DevLayout>;

    case 'default':
    default:
      return <DefaultLayout>{children}</DefaultLayout>;
  }
};

// HOC để wrap component với layout
export function withLayout<P extends Record<string, any> = {}>(
  WrappedComponent: React.ComponentType<P>,
  layoutType?: LayoutType
): React.ComponentType<P> {
  const WithLayoutComponent = (props: P) => {
    return (
      <LayoutRenderer customLayout={layoutType}>
        <WrappedComponent {...props} />
      </LayoutRenderer>
    );
  };

  WithLayoutComponent.displayName = `withLayout(${WrappedComponent.displayName || WrappedComponent.name})`;

  return WithLayoutComponent;
}

export default LayoutRenderer;
